import { jsx as _jsx } from "react/jsx-runtime";
import { useEffectiveTcGroups } from '@/hooks/use-tc-groups';
import { GroupReportingSurface } from './GroupReportingSurface';
/**
 * Settings → Teleconsultation groups → Manage → Reporting. One of the two
 * doors onto GroupReportingSurface (the other is the top-level
 * Teleconsultation reporting category); the surface itself is the single
 * implementation.
 *
 * Editing mirrors the backend's group-admin write gate — super admins arrive
 * here with a synthetic 'admin' role from useEffectiveTcGroups.
 */
export function GroupReportingTab({ groupId }) {
    const { groups } = useEffectiveTcGroups();
    const canEdit = groups.find((g) => g.id === groupId)?.role === 'admin';
    return _jsx(GroupReportingSurface, { groupId: groupId, canEdit: canEdit });
}
